import { Box, Grid } from '@mui/material'
import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export default function CurrencyExchange({ result = [] }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  // console.log(result)
  return (
    <Box display={'flex'} flexDirection={'column'} height={'100%'}>
      <Box>
        <Box display={'flex'} sx={{ fontSize: 20, fontWeight: 500 }}>
          <Box sx={{ height: 25, width: 25, mr: 1, overflow: 'hidden' }}>
            <img style={{ marginTop: '-8px' }} src="/images/Forex.png" alt="" />
          </Box>
          {/* LAP-733 (GE022) */}
          <Box>{t('investments.markeet.forex.title')}</Box>
        </Box>
        <Box sx={{ display: 'flex' }}>
          {/* LAP-733 (GE022) */}
          <Box sx={{ color: 'gray' }}>{t('investments.markeet.forex.subtitle')}</Box>
        </Box>
      </Box>

      <Box
        mt={2}
        sx={{
          '.fbox': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          },
          '.fimg': { mr: 1, width: 28, height: 28 },
          '.fimg img': { height: '100%', width: '100%' },
          '.fbcenter': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          },
          '.cbox': { fontSize: 10, textAlign: 'center' },
          '.cuy': { fontSize: 9 },
          '.red': { color: 'red' },
          '.green': { color: 'green' },
        }}
      >
        <Grid container spacing={2}>
          {result.map((item, index) => (
            <Grid item xs={2} dangerouslySetInnerHTML={{ __html: item.html }} key={index} />
          ))}
        </Grid>
      </Box>
      {/* <Box mt={2}>
        <Grid container spacing={2}>
          <Grid item xs={2}>
            <Box>Devise</Box>
          </Grid>
          <Grid item xs={2}>
            <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100%'}>
              <Box component={'samp'} width={28} mr={1}>
                <img alt="" src="/score3.png" />
              </Box>
              <Box component={'samp'}>EUR</Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100%'}>
              <Box component={'samp'} width={28} mr={1}>
                <img alt="" src="/score3.png" />
              </Box>
              <Box component={'samp'}>EUR</Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100%'}>
              <Box component={'samp'} width={28} mr={1}>
                <img alt="" src="/score3.png" />
              </Box>
              <Box component={'samp'}>EUR</Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100%'}>
              <Box component={'samp'} width={28} mr={1}>
                <img alt="" src="/score3.png" />
              </Box>
              <Box component={'samp'}>EUR</Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100%'}>
              <Box component={'samp'} width={28} mr={1}>
                <img alt="" src="/score3.png" />
              </Box>
              <Box component={'samp'}>EUR</Box>
            </Box>
          </Grid>

          <Grid item xs={2}>
            <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100%'}>
              <Box component={'samp'} width={28} mr={1}>
                <img alt="" src="/score3.png" />
              </Box>
              <Box component={'samp'}>EUR</Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box fontSize={10} textAlign={'center'}>
              1{' '}
              <Box component={'samp'} fontSize={9}>
                USD
              </Box>
              =0.918 <br />
              <Box component={'samp'} fontSize={9}>
                EUR
              </Box>
              <br />
              <Box component={'samp'} color={'red'}>
                +0.00%
              </Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box fontSize={10} textAlign={'center'}>
              1{' '}
              <Box component={'samp'} fontSize={9}>
                USD
              </Box>
              =0.918 <br />
              <Box component={'samp'} fontSize={9}>
                EUR
              </Box>
              <br />
              <Box component={'samp'} color={'red'}>
                +0.00%
              </Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box fontSize={10} textAlign={'center'}>
              1{' '}
              <Box component={'samp'} fontSize={9}>
                USD
              </Box>
              =0.918 <br />
              <Box component={'samp'} fontSize={9}>
                EUR
              </Box>
              <br />
              <Box component={'samp'} color={'red'}>
                +0.00%
              </Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box fontSize={10} textAlign={'center'}>
              1{' '}
              <Box component={'samp'} fontSize={9}>
                USD
              </Box>
              =0.918 <br />
              <Box component={'samp'} fontSize={9}>
                EUR
              </Box>
              <br />
              <Box component={'samp'} color={'red'}>
                +0.00%
              </Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box fontSize={10} textAlign={'center'}>
              1{' '}
              <Box component={'samp'} fontSize={9}>
                USD
              </Box>
              =0.918 <br />
              <Box component={'samp'} fontSize={9}>
                EUR
              </Box>
              <br />
              <Box component={'samp'} color={'red'}>
                +0.00%
              </Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100%'}>
              <Box component={'samp'} width={28} mr={1}>
                <img alt="" src="/score3.png" />
              </Box>
              <Box component={'samp'}>EUR</Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box fontSize={10} textAlign={'center'}>
              1{' '}
              <Box component={'samp'} fontSize={9}>
                USD
              </Box>
              =0.918 <br />
              <Box component={'samp'} fontSize={9}>
                EUR
              </Box>
              <br />
              <Box component={'samp'} color={'red'}>
                +0.00%
              </Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box fontSize={10} textAlign={'center'}>
              1{' '}
              <Box component={'samp'} fontSize={9}>
                USD
              </Box>
              =0.918 <br />
              <Box component={'samp'} fontSize={9}>
                EUR
              </Box>
              <br />
              <Box component={'samp'} color={'red'}>
                +0.00%
              </Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box fontSize={10} textAlign={'center'}>
              1{' '}
              <Box component={'samp'} fontSize={9}>
                USD
              </Box>
              =0.918 <br />
              <Box component={'samp'} fontSize={9}>
                EUR
              </Box>
              <br />
              <Box component={'samp'} color={'red'}>
                +0.00%
              </Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box fontSize={10} textAlign={'center'}>
              1{' '}
              <Box component={'samp'} fontSize={9}>
                USD
              </Box>
              =0.918 <br />
              <Box component={'samp'} fontSize={9}>
                EUR
              </Box>
              <br />
              <Box component={'samp'} color={'red'}>
                +0.00%
              </Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box fontSize={10} textAlign={'center'}>
              1{' '}
              <Box component={'samp'} fontSize={9}>
                USD
              </Box>
              =0.918 <br />
              <Box component={'samp'} fontSize={9}>
                EUR
              </Box>
              <br />
              <Box component={'samp'} color={'red'}>
                +0.00%
              </Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100%'}>
              <Box component={'samp'} width={28} mr={1}>
                <img alt="" src="/score3.png" />
              </Box>
              <Box component={'samp'}>EUR</Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box fontSize={10} textAlign={'center'}>
              1{' '}
              <Box component={'samp'} fontSize={9}>
                USD
              </Box>
              =0.918 <br />
              <Box component={'samp'} fontSize={9}>
                EUR
              </Box>
              <br />
              <Box component={'samp'} color={'red'}>
                +0.00%
              </Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box fontSize={10} textAlign={'center'}>
              1{' '}
              <Box component={'samp'} fontSize={9}>
                USD
              </Box>
              =0.918 <br />
              <Box component={'samp'} fontSize={9}>
                EUR
              </Box>
              <br />
              <Box component={'samp'} color={'red'}>
                +0.00%
              </Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box fontSize={10} textAlign={'center'}>
              1{' '}
              <Box component={'samp'} fontSize={9}>
                USD
              </Box>
              =0.918 <br />
              <Box component={'samp'} fontSize={9}>
                EUR
              </Box>
              <br />
              <Box component={'samp'} color={'red'}>
                +0.00%
              </Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box fontSize={10} textAlign={'center'}>
              1{' '}
              <Box component={'samp'} fontSize={9}>
                USD
              </Box>
              =0.918 <br />
              <Box component={'samp'} fontSize={9}>
                EUR
              </Box>
              <br />
              <Box component={'samp'} color={'red'}>
                +0.00%
              </Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box fontSize={10} textAlign={'center'}>
              1{' '}
              <Box component={'samp'} fontSize={9}>
                USD
              </Box>
              =0.918 <br />
              <Box component={'samp'} fontSize={9}>
                EUR
              </Box>
              <br />
              <Box component={'samp'} color={'red'}>
                +0.00%
              </Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100%'}>
              <Box component={'samp'} width={28} mr={1}>
                <img alt="" src="/score3.png" />
              </Box>
              <Box component={'samp'}>EUR</Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box fontSize={10} textAlign={'center'}>
              1{' '}
              <Box component={'samp'} fontSize={9}>
                USD
              </Box>
              =0.918 <br />
              <Box component={'samp'} fontSize={9}>
                EUR
              </Box>
              <br />
              <Box component={'samp'} color={'red'}>
                +0.00%
              </Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box fontSize={10} textAlign={'center'}>
              1{' '}
              <Box component={'samp'} fontSize={9}>
                USD
              </Box>
              =0.918 <br />
              <Box component={'samp'} fontSize={9}>
                EUR
              </Box>
              <br />
              <Box component={'samp'} color={'red'}>
                +0.00%
              </Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box fontSize={10} textAlign={'center'}>
              1{' '}
              <Box component={'samp'} fontSize={9}>
                USD
              </Box>
              =0.918 <br />
              <Box component={'samp'} fontSize={9}>
                EUR
              </Box>
              <br />
              <Box component={'samp'} color={'red'}>
                +0.00%
              </Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box fontSize={10} textAlign={'center'}>
              1{' '}
              <Box component={'samp'} fontSize={9}>
                USD
              </Box>
              =0.918 <br />
              <Box component={'samp'} fontSize={9}>
                EUR
              </Box>
              <br />
              <Box component={'samp'} color={'red'}>
                +0.00%
              </Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box fontSize={10} textAlign={'center'}>
              1{' '}
              <Box component={'samp'} fontSize={9}>
                USD
              </Box>
              =0.918 <br />
              <Box component={'samp'} fontSize={9}>
                EUR
              </Box>
              <br />
              <Box component={'samp'} color={'red'}>
                +0.00%
              </Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100%'}>
              <Box component={'samp'} width={28} mr={1}>
                <img alt="" src="/score3.png" />
              </Box>
              <Box component={'samp'}>EUR</Box>
            </Box>
          </Grid>

          <Grid item xs={2}>
            <Box fontSize={10} textAlign={'center'}>
              1{' '}
              <Box component={'samp'} fontSize={9}>
                USD
              </Box>
              =0.918 <br />
              <Box component={'samp'} fontSize={9}>
                EUR
              </Box>
              <br />
              <Box component={'samp'} color={'red'}>
                +0.00%
              </Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box fontSize={10} textAlign={'center'}>
              1{' '}
              <Box component={'samp'} fontSize={9}>
                USD
              </Box>
              =0.918 <br />
              <Box component={'samp'} fontSize={9}>
                EUR
              </Box>
              <br />
              <Box component={'samp'} color={'red'}>
                +0.00%
              </Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box fontSize={10} textAlign={'center'}>
              1{' '}
              <Box component={'samp'} fontSize={9}>
                USD
              </Box>
              =0.918 <br />
              <Box component={'samp'} fontSize={9}>
                EUR
              </Box>
              <br />
              <Box component={'samp'} color={'red'}>
                +0.00%
              </Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box fontSize={10} textAlign={'center'}>
              1{' '}
              <Box component={'samp'} fontSize={9}>
                USD
              </Box>
              =0.918 <br />
              <Box component={'samp'} fontSize={9}>
                EUR
              </Box>
              <br />
              <Box component={'samp'} color={'red'}>
                +0.00%
              </Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box fontSize={10} textAlign={'center'}>
              1{' '}
              <Box component={'samp'} fontSize={9}>
                USD
              </Box>
              =0.918 <br />
              <Box component={'samp'} fontSize={9}>
                EUR
              </Box>
              <br />
              <Box component={'samp'} color={'red'}>
                +0.00%
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box> */}
    </Box>
  )
}
